import React from "react";

const RoleMatrix=()=>{
    return(
        <>
        <p>RoleMatrix</p>
        </>
    )
}
export default RoleMatrix